import type { Project } from '../types.ts';

/**
 * #1591 — het project om mee te starten. De standaardlijst laat gearchiveerde
 * projecten weg; wie een gearchiveerd dossier open had, kwam na herladen stil in
 * het eerste project uit de lijst terecht. Nu wordt het laatst geopende project
 * ook in het archief gezocht; pas als het echt weg is, het eerste project — en
 * `teruggevallen`, zodat de app dat kan melden.
 */
export async function kiesStartProject(
  projecten: Project[],
  laatsteId: string | null | undefined,
  laadMetArchief: () => Promise<Project[]>
): Promise<{ project: Project | undefined; teruggevallen: boolean }> {
  const eerste = projecten[0];
  if (!laatsteId) return { project: eerste, teruggevallen: false };
  const gevonden = projecten.find((p) => p.id === laatsteId);
  if (gevonden) return { project: gevonden, teruggevallen: false };
  try {
    const uitArchief = (await laadMetArchief()).find((p) => p.id === laatsteId && !p.deleted_at);
    if (uitArchief) return { project: uitArchief, teruggevallen: false };
  } catch {
    // Archief niet op te vragen (offline): terugvallen, niet vastlopen.
  }
  return { project: eerste, teruggevallen: !!eerste };
}
